import {Component, CUSTOM_ELEMENTS_SCHEMA, HostBinding, Input, NgModule, ViewEncapsulation} from '@angular/core';
import {ICON_SIZE} from 'shared/magic';
import {CommonModule} from '@angular/common';
import {IconSpriteModule} from 'ng-svg-icon-sprite';

@Component({
	selector: 'shared-icon-sprite',
	template: `
		<ng-container *ngIf="svgId">
			<div class="sprite-icon-wrapper">
				<div class="sprite-icon-layout d-flex justify-content-center align-items-center"
					 [ngClass]="iconClass">
					<svg-icon-sprite
						[src]="'assets/sprites/sprite.svg#' + svgId"
						[height]="height"
						[width]="width"
						[viewBox]="viewBox"
					></svg-icon-sprite>
				</div>
			</div>
		</ng-container>
	`,
	styles: [
		`.sprite-icon-wrapper {transition: all;}
		.sprite-icon-layout {color: inherit;}`
	],
	encapsulation: ViewEncapsulation.None
})
export class IconSpriteComponent {
	@HostBinding('style') get AddStyleToHost() { return {zIndex: this.zIndex}; }

	@Input() svgId: string;
	@Input() iconClass: string;
	@Input() height: string = ICON_SIZE;
	@Input() width: string = ICON_SIZE;
	@Input() viewBox = '0 0 24 24';
	@Input() zIndex = 0;

	constructor() { }
}

@NgModule({
	imports: [
		CommonModule,
		IconSpriteModule
	],
	declarations: [
		IconSpriteComponent
	],
	exports: [
		IconSpriteComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class IconSpritesModule { }
